import { Link } from "react-router-dom";

const product_img_menu = [
    {
        id: 1,
        category: "UTRUSTNING",
        product_name: "LJUD",
        thumb: "./images/1.png",
        onclick: "ljud/ljudsubmeny",
        level: 2,
    },
    {
        id: 2,
        category: "UTRUSTNING",
        product_name: "LJUS",
        thumb: "./images/ljus/ljus.png",
        level: 2
    },
    {
        id: 3,
        category: "UTRUSTNING",
        product_name: "KABEL",
        thumb: "./images/kabel.png",
        level: 2
    },
    {
        id: 4,
        category: "UTRUSTNING",
        product_name: "RIGGING",
        thumb: "./images//rigging/rigging.png",
        level: 2
    },
    {
        id: 5,
        category: "UTRUSTNING",
        product_name: "ÖVRIGT",
        thumb: "./images/no_img.png",
        level: 2
    },
// LJUD
    {
        id: 10,
        category: "LJUD",
        product_name: "LINEARRAY",
        thumb: "./images/ljud/Linearray.png",
        level: 3
    },
    {
        id: 11,
        category: "LJUD",
        product_name: "HÖGTALARE",
        thumb: "./images/no_img.png",
        level: 3
    },
    {
        id: 12,
        category: "LJUD",
        product_name: "Mixerbord",
        thumb: "./images/ljud/mixerbord.png",
        level: 3
    },
    {
        id: 13,
        category: "LJUD",
        product_name: "Signalhantering",
        thumb: "./images/no_img.png",
        level: 3
    },
    {
        id: 14,
        category: "LJUD",
        product_name: "DJ Utrustning",
        thumb: "./images/ljud/djutrustning.png",
        level: 3
    },
    {
        id: 15,
        category: "LJUD",
        product_name: "Mikrofoner",
        thumb: "./images/ljud/mikrofon.png",
        level: 3
    },
    {
        id: 16,
        category: "LJUD",
        product_name: "Trådlösa system",
        thumb: "./images/ljud/wl.png",
        level: 3
    },
    {
        id: 17,
        category: "LJUD",
        product_name: "Lineboxar",
        thumb: "./images/no_img.png",
        level: 3
    },
    {
        id: 18,
        category: "LJUD",
        product_name: "Ljudstativ",
        thumb: "./images/no_img.png",
        level: 3
    },
    {
        id: 19,
        category: "LJUD",
        product_name: "Ljudtillbehör",
        thumb: "./images/no_img.png",
        level: 3
    },

//LJUS
    {
        id: 21,
        category: "LJUS",
        product_name: "Ljusbord",
        thumb: "./images/ljus/ljusbord.png",
        level: 3
    },{
        id: 22,
        category: "LJUS",
        product_name: "DMX distribution",
        thumb: "./images/ljus/signalhantering.png",
        level: 3
    },
    {
        id: 23,
        category: "LJUS",
        product_name: "Moving Heads",
        thumb: "./images/ljus/movingheads.png",
        level: 3
    },
    {
        id: 24,
        category: "LJUS",
        product_name: "Ramper",
        thumb: "./images/ljus/ledbar.png",
        level: 3
    },
   
    {
        id: 25,
        category: "LJUS",
        product_name: "LED",
        thumb: "./images/ljus/ledpar.png",
        level: 3
    },
    {
        id: 26,
        category: "LJUS",
        product_name: "Rökmaskiner",
        thumb: "./images/ljus/smoke.png",
        level: 3
    },
    {
        id: 27,
        category: "LJUS",
        product_name: "Övrigt",
        thumb: "./images/ljus/effects.png",
        level: 3
    },

// KABEL
    {
        id: 51,
        category: "KABEL",
        product_name: "Elcentraler",
        thumb: "./images/no_img.png",
        level: 3
    },
    {
        id: 52,
        category: "KABEL",
        product_name: "3-Fas kabel",
        thumb: "./images/no_img.png",
        level: 3
    },
    {
        id: 53,
        category: "KABEL",
        product_name: "Strömkabel",
        thumb: "./images/no_img.png",
        level: 3
    },
    {
        id: 54,
        category: "KABEL",
        product_name: "Ljudkabel",
        thumb: "./images/no_img.png",
        level: 3
    },
    {
        id: 55,
        category: "KABEL",
        product_name: "DMX kabel",
        thumb: "./images/no_img.png",
        level: 3
    },
    {
        id: 56,
        category: "KABEL",
        product_name: "Nätverkskabel",
        thumb: "./images/no_img.png",
        level: 3
    },
    {
        id: 57,
        category: "KABEL",
        product_name: "BNC kabel",
        thumb: "./images/no_img.png",
        level: 3
    },
    {
        id: 58,
        category: "KABEL",
        product_name: "Övrig kabel",
        thumb: "./images/no_img.png",
        level: 3
    },
    {
        id: 59,
        category: "KABEL",
        product_name: "Kabelskydd",
        thumb: "./images/kabel/kabelskydd.png",
        level: 3
    },

// Rigging
{
    id: 60,
    category: "RIGGING",
    product_name: "Lyftredskap",
    thumb: "./images/no_img.png",
    level: 3
},
{
    id: 61,
    category: "RIGGING",
    product_name: "F31 Truss",
    thumb: "./images/rigging/F31050B.png",
    level: 3
},
{
    id: 62,
    category: "RIGGING",
    product_name: "F32 Truss",
    thumb: "./images/rigging/F32050.png",
    level: 3
},
{
    id: 64,
    category: "RIGGING",
    product_name: "F34 Truss",
    thumb: "./images/rigging/F34050.png",
    level: 3
},
{
    id: 65,
    category: "RIGGING",
    product_name: "Ground Support",
    thumb: "./images/rigging/F34tower.png",
    level: 3
},
{
    id: 66,
    category: "RIGGING",
    product_name: "Specialdelar",
    thumb: "./images/no_img.png",
    level: 3
},
{
    id: 67,
    category: "RIGGING",
    product_name: "Övrig Rgging",
    thumb: "./images/no_img.png",
    level: 3
},

// Övrigt
{
    id: 81,
    category: "ÖVRIGT",
    product_name: "Kom-radios",
    thumb: "./images/diverse/komradio.png",
    level: 3
},
{
    id: 82,
    category: "ÖVRIGT",
    product_name: "Tyger",
    thumb: "./images/no_img.png",
    level: 3
},
{
    id: 95,
    category: "TILL SALU",
    product_name: "Begagnat Ljud",
    thumb: "./images/no_img.png",
    level: 3
},


// LJUD

// Line Array
    
        {
            id: 10001,
            level: 4,
            category: "LINEARRAY",
            product_name: "KOMPLETT SYSTEM",
            producer: "DB Technologies",
            artnr: "010-001",
             
            description:
              "Hur ett system ser ut beror på vad eventet kräver och hur lokalen ser ut. Systemet går både att monteras ståendes på basarna s.k. Ground stackat eller hängandes s.k. Flygandes. I båda fallen utgår man från flygramen. katMer information kommer.",
            
              all_lists:[
                {
                    list_data:" ",
                },
                {
                    list_data:"Systemet består i bland annat av:",
                },
                {
                    list_data:" ",
                },
                {
                    list_data:"DRK-10 Flygram",
                },
                {
                    list_data:"DVA T12 Line Array modul",
                },
                {
                    list_data:"DVA T8 Line Array modul",
                },
                {
                    list_data:"DVA S10 basar 1 x 18\" (Går att flyga)",
                },
                {
                    list_data:"DVA S30n 2 x 18\" basar",
                },
                {
                    list_data:"RDnet Controller",
                },
 
 
            ],
    
            featured: "true",
            
         //gallery images
             thumb: "./images/ljud/komplete_system.png",
            
             gallery_img:[
                {
                    img:"./images/ljud/dvat12_1.png",
                },
                {
                    img:"./images/ljud/dvat12back.png",
                },
                {
                    img:"./images/ljud/dvat12case.png",
                },
               
            ] ,
    
             // technical
             dimension:'Beror på systemet',
             vikt_1:'Beror på systemet',
    
           // all cases
           all_cases:[ 
            {
                case_info:'Flygramar, handspel kabel m.m.',
                vikt_2:"70 kg",
                storlek:"1200 x 600 x 600 cm",
            },
            {
                case_info:'För 2 st DVA T12',
                vikt_2:"76 kg",
                storlek:"800 x 600 x 1000 cm",
            },
            {
                case_info:'För 4 st DVA T8',
                vikt_2:"78 kg",
                storlek:"800 x 600 x 1000 cm",
            },
        
         ],
          
            // icons
            icons:[
                {
                    icon:"./images/icons/powercon.png",
                    hovertext:'PowerCon',
                },
                {
                    icon:"./images/icons/rdnet.png",
                    hovertext:'RDNet',
                },
                {
                    icon:"./images/icons/rj45.png",
                    hovertext:'RJ45',
                }
            ] ,
    
          // download
          downloadable_link:[
            {
                d_img:"./images/download.png",
                d_heading:"DVA T12 Manual",
                d_link:"./downloads/DVA T12.pdf"
            },
            {
                d_img:"./images/download.png",
                d_heading:"DVA T12 Datasheet",
                d_link:"./downloads/DVA T12 Datasheet.pdf"
            }
        ],
    },
    
    {
        id: 10-101,
        level: 4,
        category: "LINEARRAY",
        product_name: "DVA T12",
        producer: "DB Technologies",
        artnr: "010-101",

        description:
        "Aktiv Line Array-modul 12\"/6.5\"/1\", 1500 Watt RMS. DVA T12 är den större lådan i vårat Line Array system. Även om den ger mer kraft och har större räckvidd, och dess aktiva trevägsdelning gör den enkel att installera. Levereras i case med 2 st. Via inbyggda RDNet fås full kontroll över systemet från mixplatsen, därigenom blir det möjligt att reglera nivåer, konfigurera och välja olika presets, testning av individuella komponenter och se status över temperatur etc.",

        all_lists:[
            {
                list_data:" ",
            },
            {
                list_data:"Speaker Type: 3-Way Active Line Array Module",
            },
            {
                list_data:"Frequency Response [-6dB]: 60 - 19.000 Hz",
            },
            {
                list_data:"Max SPL: 136 dB One Unit",
            },
            {
                list_data:"HF: 3x1\"",
            },
            {
                list_data:"Voice Coil HF: 1.4\"",
            },
            {
                list_data:"Directivity: 100x10° Single unit",
            },
            {
                list_data:"Horn: Integrated CD Horn",
            },
            {
                list_data:"MF: 2x 6.5\"",
            },
            {
                list_data:"Type: MF Neodymium, Sealed Basket, Phase plug, Horn loaded",
            },
            {
                list_data:"Voice Coil Mf: 2\"",
            },
            {
                list_data:"LF: 12\"",
            },
            {
                list_data:"Type LF: Neodymium",
            },
            {
                list_data:"Voice Coil LF: 3\"",
            },
            {
                list_data:"Amp technology: Digipro G2",
            },
            {
                list_data:"Amp Class: Class D",
            },
            {
                list_data:"HF Amp: 350 W",
            },
            {
                list_data:"MF Amp: 350 W",
            },
            {
                list_data:"LF Amp: 710 W",
            },
            {
                list_data:"Controller: DSP 56 bit",
            },
            {
                list_data:"System Presets: 8, HF/Low-mid correction",
            },
            {
                list_data:"Signal: 1 x XLR in, 1 x XLR out",
            },
            {
                list_data:"Network: RDnet RJ45 in/out",
            },
            {
                list_data:"Power: 1 x PowerCon in, 1 x PowerCon out",
            },
        ],

        featured: "true",
         //gallery images
         thumb: "./images/ljud/dvat12_1.png",
         gallery_img:[
            {
                img:"./images/ljud/dvat12_1.png",
            },
            {
                img:"./images/ljud/dvat12back.png",
            },
            {
                img:"./images/ljud/dvat12case.png",
            },
           
        ] ,

         // technical
         dimension:'58 x 38 x 43 cm',
         vikt_1:'30 kg',

       // all cases
       all_cases:[ 
        {
            case_info:'För 2 st DVA T12',
            vikt_2:"76 kg",
            storlek:"800 x 600 x 1000 cm",
        },
    
     ],
      
        // icons
        icons:[
            {
                icon:"./images/icons/powercon.png",
                hovertext:'PowerCon',
            },
            {
                icon:"./images/icons/xlr3polv4.png",
                hovertext:'XLR 3-pol',
            },
            {
                icon:"./images/icons/rdnet.png",
                hovertext:'RDNet',
            },
            {
                icon:"./images/icons/rj45.png",
                hovertext:'RJ45',
            }
        ] ,

      // download
      downloadable_link:[
        {
            d_img:"./images/download.png",
            d_heading:"DVA T12 Manual",
            d_link:"./downloads/DVA T12.pdf"
        },
        {
            d_img:"./images/download.png",
            d_heading:"DVA T12 Datasheet",
            d_link:"./downloads/DVA T12 Datasheet.pdf"
        }
    ],
},

    {
        id: 10-102,
        artnr: "010-102",
        category: "LINEARRAY",
        product_name: "DVA T8",
        producer: "DB Technologies",
        thumb: "./images/ljud/dvat8.png",
        level: 4,
         // 
       description:
       "Mer info kommer",   
       image: "./images/ljud/dvat8.png",
        featured: "true",


         //gallery images
         gallery_img:[
            {

            },
           
        ] ,
         // technical
         dimension:'29 x 29 x 29 cm',
         vikt_1:'30 kg',

       // all cases
       all_cases:[ 
        {
            case_info:'För 4 st DVA T8',
            vikt_2:"76 kg",
            storlek:"800 x 600 x 1000 cm",
        },
        
     ],
    },
    {
        id: 10-122,
        artnr: "010-122",
        category: "LINEARRAY",
        product_name: "DVA S10",
        producer: "DB Technologies",
        thumb: "./images/ljud/dvas10.png",
        level: 4,
         // 
       description:
          "Line array speaker zoom range from narrow 6° beam to wide 50° wash, Uniform illumination of the light cone. Sophisticated fan management with three selectable modes: Silent, Max and Auto. Adjustable pan and tilt range with selectable start and end points. 4 Selectable dimmer curves. Adjustable PWM",
        image: "./images/ljud/dvats10.png",
        featured: "true",
         // technical
         dimension:'29 x 29 x 29 cm',
         vikt_1:'30 kg',

       // all cases
       all_cases:[ 
        {
            case_info:'För 4 st DVA T8',
            vikt_2:"76 kg",
            storlek:"800 x 600 x 1000 cm",
        },
        
     ],
    },
    {
        id: 10-123,
        artnr: "010-123",
        category: "LINEARRAY",
        producer: "DB Technologies",
        product_name: "DVA S30N",
        thumb: "./images/ljud/dvas30n.png",
        level: 4
    },
    
    {
        id: 10-191,
        level: 4,
        category: "LINEARRAY",
        product_name: "DRK-10 Flygram",
        producer: "DB Technologies",
        artnr: "010-191",

        description:
        "DVAs flygram kan flyga upp till 16 st DVA T4 eller 3 st DVA S10. Ramen är väl balanserad och har flera fästpunkter för hur högtalarna under hängs och för rätt vinkling. Om de inte finns någon möjlighet att flyga högtalarna så kan man även använda ramen för s.k. ground stack.",

        all_lists:[
            
        ],

        featured: "true",
         //gallery images
         thumb: "./images/ljud/drk-10.png",
         gallery_img:[
            {
                img:"./images/ljud/drk-10.png",
            },
            
           
        ] ,

         // technical
         dimension:'58 x 38 x 43 cm',
         vikt_1:'30 kg',

       // all cases
       all_cases:[ 
       
    
     ],
      
        // icons
        icons:[
              ] ,

      // download
      downloadable_link:[
        {
            d_img:"./images/download.png",
            d_heading:"DVA T12 Manual",
            d_link:"./downloads/DVA T12.pdf"
        },
        {
            d_img:"./images/download.png",
            d_heading:"DVA T12 Datasheet",
            d_link:"./downloads/DVA T12 Datasheet.pdf"
        }
    ],
},
    {
        id: 10-195,
        artnr: "010-195",
        category: "LINEARRAY",
        product_name: "RDNet Controler 8",
        producer: "Db Technologies",
        thumb: "./images/ljud/rdnet8.png",
        level: 4
    },
    {
        id: 10-199,
        artnr: "010-195",
        category: "LINEARRAY",
        product_name: "LineArray PSU",
        producer: "SLDRS",
        thumb: "./images/no_img.png",
        level: 4
    },
  
// Högtalare
    {
        id: 11-195,
        artnr: "010-555",
        category: "HÖGTALARE",
        product_name: "DVX D8HP",
        producer: "DB Technologies",
        thumb: "./images/ljud/dvx8.png",
        level: 4
    },
    {
        id: 11-194,
        artnr: "010-555",
        category: "HÖGTALARE",
        product_name: "DVX D12HP",
        producer: "DB Technologies",
        thumb: "./images/ljud/dvx12.png",
        level: 4
    },
    {
        id: 10-515,
        artnr: "010-515",
        category: "HÖGTALARE",
        product_name: "DVX D15",
        producer: "DB Technologies",
        thumb: "./images/ljud/dvx15.png",
        level: 4
    },
    {
        id: 11-197,
        artnr: "010-555",
        category: "HÖGTALARE",
        product_name: "Opera 405D",
        producer: "DB Technologies",
        thumb: "./images/ljud/opera.png",
        level: 4
    },
    {
        id: 11-198,
        artnr: "010-555",
        category: "HÖGTALARE",
        product_name: "DVX DM15",
        producer: "DB Technologies",
        thumb: "./images/ljud/dvxDM15.png",
        level: 4
    },


    // Mixerbord
    {
        id: 120,
        category: "Mixerbord",
        product_name: "KOMPLETT SYSTEM MED MIXER OCH WL",
        thumb: "./images/no_img.png",
        level: 4
    },
    {
        id: 11-201,
        category: "Mixerbord",
        product_name: "CQ18T",
        level: 4,
        producer: "Allen & Heath",
        artnr: "011-201",
        description:
          "CQ-18T är en ultrakompakt digitalmixer designad för att användas lokalt med sin inbyggda pekskärm och fysiska kontroller, på distans med hjälp av dess inbyggda WiFi eller genom anslutning till en trådbunden eller trådlöst nätverk. Byggd på en 96kHz processor, den är rik på anslutningsmöjligheter med Bluetooth, trådlösa alternativ, SD- och USB-ljudinspelning och uppspelning. Med fokus på hastighet och användarvänlighet. ",
          
          all_lists:[
            {
                list_data: "16 Mic/Line-förförstärkare 8x XLR + 8x XLRTRS Combi",
            },
            {
                list_data:"Balanserad stereo linjeingång, 2x TRS",
            },
            {
                list_data:"Main LR, 2x XLR",
            },
            {
                list_data:"6 x monitormixar, 6x TRS ",
            },
{
                list_data:"2x tilldelbara hörlursutgångar, 2x 6,35 mm TRS",
            },
{
                list_data:"24x22 USB-B-gränssnitt",
            },
{
                list_data:"24x22 SD-inspelning/uppspelning",
            },
{
                list_data:"Stereo USB-inspelning/uppspelning med dedikerad ingångskanal Stereo Bluetooth-uppspelning med dedikerad ingångskanal",
            },
{
                list_data:"4x FX Assist engines",
 },
{
                list_data:"3x anpassade mjukvaruknappar",
            },
{
                list_data:"3x Smart Rotary",
            },
{
                list_data:"Dubbla footswitch-anslutningar",
            },
{
                list_data:"7” Kapacitiv pekskärm med tillhörande vridreglage",
            },
{
                list_data:"Inbyggd dual band 2,4G/5G AC Wi-Fi med automatiskt kanalval",
            },


        ],
        
        featured: "true",
        thumb: "./images/ljud/CQ-18T-Top.png",
        //gallery images
        gallery_img:[
            {
                img:"./images/ljud/CQ-18T-Top.png",
            },
                      
           
        ] ,

        // technical
        dimension:'346 x 242 x 88 mm',
        vikt_1:'3 kg',
        // all cases
        all_cases:[ 
          
         ],
         
        // icons
        icons:[
            {
                icon:"./images/icons/triggerclamp.png",
                hovertext:'Trigger clamp',
            },
            {
                icon:"./images/icons/xlr3polv4.png",
                hovertext:'DMX 3-pol',
            }
        ] ,
        // download
        downloadable_link:[
            {
                d_img:"./images/download.png",
                d_heading:"CQ-series User guide",
                d_link:"./downloads/CQ_User_Guide_V1_2_0.pdf"
            },
           
        ],
    },


    {
        id: 11-195,
        artnr: "010-195",
        category: "Mixerbord",
        product_name: "LS9 32 ch",
        producer: "Yamaha",
        thumb: "./images/ljud/ls932.png",
        level: 4
    },
    {
        id: 11-196,
        artnr: "010-195",
        category: "Mixerbord",
        product_name: "SQ6",
        producer: "Allen & Heath",
        thumb: "./images/ljud/sq6.png",
        level: 4
    },
    {
        id: 11195,
        artnr: "010-195",
        category: "Mixerbord",
        product_name: "VLZ 1402",
        thumb: "./images/ljud/vlz1402.png",
        producer: "Mackie",
        level: 4
    },
    {
        id: 11491,
        artnr: "011-491",
        category: "Mixerbord",
        product_name: "MMX-602",
        thumb: "./images/no_img.png",
        producer: "StageLine",
        level: 4
    },
    {
        id: 10198,
        artnr: "010-198",
        category: "Mixerbord",
        product_name: "SB168",
        thumb: "./images/ljud/sb168.png",
        producer: "Yamaha",
        level: 4
    },

    // Signalhantering
    
    {
        id: 13302,
        artnr: "013-302",
        category: "Signalhantering",
        product_name: "iEQ31",
        thumb: "./images/no_img.png",
        producer: "DBX",
        level: 4
    },
    {
        id: 13901,
        artnr: "013-901",
        category: "Signalhantering",
        product_name: "SP8 Splitter",
        thumb: "./images/no_img.png",
        producer: "Millenium",
        level: 4
    },
    {
        id: 13902,
        artnr: "013-902",
        category: "Signalhantering",
        product_name: "Splitt It Mk2",
        thumb: "./images/no_img.png",
        producer: "T.rack",
        level: 4
    },
    {
        id: 13903,
        artnr: "013-903",
        category: "Signalhantering",
        product_name: "Eight 8",
        thumb: "./images/no_img.png",
        producer: "T.rack",
        level: 4
    },

    // DJ Utrustning
    
    {
        id: 14001,
        artnr: "014-001",
        category: "DJ Utrustning",
        product_name: "Mixdeck",
        thumb: "./images/ljud/mixdeck.png",
        producer: "Numark",
        level: 4
    },
    {
        id: 14101,
        artnr: "010-198",
        category: "DJ Utrustning",
        product_name: "HD2500",
        thumb: "./images/ljud/hd2500.png",
        producer: "Denon",
        level: 4
    },

// Mikrofoner
{
    id: 15-111,
    category: "Mikrofoner",
    producer: "JJ Labs",
    product_name: "ND6000",
    artnr: "015-111",
    thumb: "./images/ljud/nd6000.png",
    level: 4
},
    {
        id: 15-121,
        category: "Mikrofoner",
        product_name: "SM58",
        level: 4,
        producer: "Shure",
        artnr: "015-121",
        description:
          "Världens mest sålda sångmikrofon. Dynamisk.",
          all_lists:[
            {
                list_data:"list data 1",
            },
            {
                list_data:"list data 2",
            },
            {
                list_data:"list data 3",
            },
        ],
        
          pdf: "./../assets/manuals/Varytec.pdf",
        featured: "true",
        thumb: "./images/ljud/sm58.png",
        //gallery images
        gallery_img:[
            {
                img:"./images/ljud/sm58.png",
            },
            {
                img:"./images/ljud/beta57.png",
            },
            {
                img:"./images/ljud/dvx12.png",
            },
            {
                img:"./images/ljud/Co9.png",
            },
            {
                img:"./images/ljud/dvx12.png",
            },
            {
                img:"./images/ljud/Co9.png",
            },
            {
                img:"./images/ljud/Co9.png",
            },
            {
                img:"./images/ljud/Co9.png",
            },
            {
                img:"./images/ljud/dvx12.png",
            },
           
        ] ,

        // technical
        dimension:'29 x 29 x 29 cm',
        vikt_1:'8,3 kg',

        // all cases
        all_cases:[ 
            {
            case_info:'För 2 st Mikrofoner Shure SM58',
            vikt_2:"22 kg",
            storlek:"600 x 600 x 1200 cm",
            },
            {
            case_info:'För 4 st Mikrofoner Shure SM58',
            vikt_2:"44 kg",
            storlek:"1600 x 1600 x 1200 cm",
            },
         ],
         
        // icons
        icons:[
            {
                icon:"./images/icons/triggerclamp.png",
                hovertext:'Trigger clamp',
            },
            {
                icon:"./images/icons/xlr3polv4.png",
                hovertext:'DMX 3-pol',
            }
        ] ,
        // download
        downloadable_link:[
            {
                d_img:"./images/download.png",
                d_heading:"Shure SM58 Manual",
                d_link:"#"
            },
            {
                d_img:"./images/download.png",
                d_heading:"Shure SM58 Drawing",
                d_link:"#"
            }
        ],
    },
    {
        id: 15-122,
        category: "Mikrofoner",
        producer: "Shure",
        product_name: "Beta 58A",
        artnr: "015-122",
        thumb: "./images/ljud/beta58.png",
        description:
          "Beta 58A har designmässigt inspirerats av SM58 men är på många sätt förbättrad. Beta 58A har snabbt blivit accepterad som den nya proffs standarden av dynamiska sångmikrofoner. Beta 58A har en superkardioid karakteristik som är konstant vid så gott som alla frekvenser, vilket minimerar rundgångsproblemet. Den har en mycket kraftig utsignal genom användande av neodymiummagnet och har en förbättrad frekvensresponse, speciellt i diskantområdet. Mycket användbar vid höga ljudnivåer. Beta 58A har extremt lågt handljud. Dynamisk superkardioid. Frekvensomfång 50-16.000Hz.",
        level: 4
    },
    {
        id: 15-131,
        category: "Mikrofoner",
        producer: "Electro Voice",
        product_name: "Co9",
        artnr: "015-131",
        thumb: "./images/ljud/Co9.png",
        description:
          "En favorit bland vokalister inom alla stilar. Den har en viss dämpning i basregistret och ett dominerande mellanregister. Frekvensomfång: 50 - 18.000 Hz",
        level: 4
    },
    {
        id: 15-132,
        category: "Mikrofoner",
        producer: "Electro Voice",
        product_name: "PL44",
        artnr: "015-132",
        thumb: "./images/ljud/pl44.png",
        description:
          "Dynamisk mikrofon med superkardioid-karaktäristik. Färgad med en extra mellanregister-/diskanthöjning för att passa direkt i alla live-sammanhang. Frekvensomfång: 80-18.000 Hz",
        level: 4
    },
     {
        id: 15-223,
        category: "Mikrofoner",
        producer: "Shure",
        product_name: "SM57",
        artnr: "015-223",
        thumb: "./images/ljud/sm57.png",
        description:
          "Klassisk standardmikrofon för trummor, slagverk och uppmickning av instrumentförstärkare. SM57 har en noggrant utformad frekvensgång som ger en ren, väl avgränsad instrumentåtergivning och fyllig, varm röståtergivning från podier och scen. Därför har den blivit en flitigt använd arbetshäst bland världens studios och scener. Dynamisk kardioid. Frekvensomfång 40-15.000 Hz.",
        level: 4
    },
    {
        id: 15-222,
        category: "Mikrofoner",
        producer: "Shure",
        product_name: "Beta 57A",
        artnr: "015-222",
        thumb: "./images/ljud/beta57.png",
        description:
          "Trots att den inte varit med så länge har Beta 57 blivit en legend inom liveljud. Denna mikrofon är konstruerad dels för sång, dels för uppmikning av både elektriska och akustiska instrument, speciellt trummor, slagverk, blås och instrumentförstärkare - både i studio och på scen. Den robusta konstruktionen gör den extremt turnévänlig och tål mycket stryk. Utgångspunkten för Beta 57A är SM57, men med neodymiummagnet som ger bättre följsamhet och maximalt signal/brusförhållande. Dessutom har Beta 57A förbättrad frekvensrespons i både bas- och diskantområdet vilket ger ett mer öppet och naturligt ljud. Superkardioid, dynamisk mikrofon. Frekvensomfång: 50-16000Hz.",
        level: 4
    },
    {
        id: 15-241,
        category: "Mikrofoner",
        producer: "AKG",
        product_name: "C391",
        artnr: "015-241",
        thumb: "./images/ljud/c391.png",
        description:
          "Cardioid kondensatormikrofon. Komplett mik, med mik-kapsel (AKG CK91) och förstärkare (AKG SE 300 B), Mikpreamp för kapslar i Blue Line-serien; CK 91, CK 92, CK 93, CK 94 samt CK 98. Den robusta Modulock bayonet-kopplingen möjliggör snabbt och enkelt byte av kapseln. SE 300 B har även en bass-roll off switch med tre olika lägen; flat/plan, 75Hz och 10 dB dämpning. AKG C91: Njure. Kännetecknas av ett slätt och välbalanserat frekvensomfång. Perfekt för liveframträdanden och studio broadcasts där det är viktigt att ljud off-axis dämpas.",
        level: 4
    },
    {
        id: 15-251,
        category: "Mikrofoner",
        producer: "Line Audio",
        product_name: "CM3",
        artnr: "015-251",
        thumb: "./images/ljud/cm3.png",
        description:
          "CM3 är en liten och enormt smidig fantommatad kondensatormikrofon som kan användas till det mesta, både i studion och på scenen. Körer, förstärkare, trummor, akustisk gitarr. Frekvensomfång: 20-20000Hz",
        level: 4
    },
    {
        id: 15-261,
        category: "Mikrofoner",
        producer: "Sennheiser",
        product_name: "MD918U",
        artnr: "015-261",
        thumb: "./images/ljud/MD918U.png",
        description:
          "V",
        level: 4
    },
    {
        id: 15-271,
        category: "Mikrofoner",
        producer: "Röde",
        product_name: "M3",
        artnr: "015-271",
        thumb: "./images/ljud/M3.png",
        description:
          "M3 är en extremt mångsidig mikrofon för användning i studion, i hemmet, vid fältinspelning, eller varhelst en lågbrusig kondensatormik med njurekaraktäristik och bred frekvensupptagning behövs. M3 har LED-indikator för batterinivå, och High Pass Filter. Levereras med vindskydd och mikrofonhållare och drivs med ett 9V batteri eller via 48V fantommatning.",
        level: 4
    },
    {
        id: 15-311,
        category: "Mikrofoner",
        producer: "Sennheiser",
        product_name: "e604",
        artnr: "015-311",
        thumb: "./images/ljud/e604.png",
        description:
          "Kardioidmikrofon med sargfäste, speciellt anpassad för uppmickning av trummor och blåsinstrument.",
        level: 4
    },
    {
        id: 15-312,
        category: "Mikrofoner",
        producer: "Sennheiser",
        product_name: "md421",
        artnr: "015-312",
        thumb: "./images/ljud/md421.png",
        description:
          "Den allmänt förekommande, ikoniska – Sennheiser MD 421 kan hittas på varje scen och studio världen över. Med sin höga SPL hantering, goda bortstötning och praktiska filter alternativ, har MD 421 länge varit en standard när det kommer till dynamiska stormembrans mikrofoner, och huvudsaklig vid inspelning av gitarr förstärkare, pukor och sång. Fungerar helt enkelt till nästan till allt!",
        level: 4
    },
    {
        id: 15-313,
        category: "Mikrofoner",
        producer: "Sennheiser",
        product_name: "e906",
        artnr: "015-313",
        thumb: "./images/ljud/e906.png",
        description:
          "Superkardioid som är framtagen för gitarrförstärkare men som även är utmärkt för perkussion och blås.",
        level: 4
    },
    {
        id: 15-421,
        category: "Mikrofoner",
        producer: "Shure",
        product_name: "Beta 52A",
        artnr: "015-421",
        thumb: "./images/ljud/beta52.png",
        description:
        "Dynamisk bastrummemik med suverän attack och ”punch”.Beta 52A är en mikrofon med hög output och ett frekvenssvar som är anpassat för bastrumma och andra lågfrekvensinstrument. Mikrofonen ger en superb attack och ”punch” med studiokvalitet även under extremt höga ljudtrycksnivåer. BETA52A har en modifierad supercardioid för att säkerställa maximal gain innan feedback och för att eliminera oönskade bakgrundsljud. Stativadapter och XLR-kontakter är byggda för att förenkla installation, speciellt när mikrofonen är placerad inuti en baskagge. Tripod adaptern håller mikrofonen fixerad i önskad position, även under kraftiga vibrationer. En robust stålgrill skyddar mikrofonen även i krävande turnésammanhang",
        level: 4
    },
    {
        id: 15-501,
        category: "Mikrofoner",
        producer: "DPA",
        product_name: "4061 Svarta",
        artnr: "015-501",
        thumb: "./images/ljud/dpa4061.png",
        description:
          "V",
        level: 4
    },
    {
        id: 15-5011,
        category: "Mikrofoner",
        producer: "DPA",
        product_name: "4061 Beiga",
        artnr: "015-5011",
        thumb: "./images/ljud/dpa4061.png",
        description:
          "V",
        level: 4
    },
    {
        id: 15505,
        category: "Mikrofoner",
        producer: "Sennheiser",
        product_name: "MKE2",
        artnr: "015-505",
        thumb: "./images/ljud/mke2.png",
        description:
          "V",
        level: 4
    },
    {
        id: 15-511,
        category: "Mikrofoner",
        producer: "DPA",
        product_name: "4066",
        artnr: "015-511",
        thumb: "./images/ljud/dpa4066.png",
        description:
          "V",
        level: 4
    },
    {
        id: 15-521,
        category: "Mikrofoner",
        producer: "Audac",
        product_name: "CMX726S",
        artnr: "015-521",
        thumb: "./images/ljud/cmx726.png",
        description:
          "V",
        level: 4
    },
    {
        id: 15-531,
        category: "Mikrofoner",
        producer: "Sennheiser",
        product_name: "Intricot HT 747",
        artnr: "015-531",
        thumb: "./images/ljud/ht747.png",
        description:
          "HT 747 är en smidig headsetmikrofon, idealisk för aerobics, idrott eller gymverksamhet. Upptagningen är supercardioid vilket gör den väldigt okänslig för rundgång/ återkoppling. Bygeln är flexibel och i ett svettåligt material. Passar till Sennheiser trådlösa system med minitele 3.5mm ingång.", 
        level: 4
       },
   
    {
        id: 15-601,
        category: "Mikrofoner",
        producer: "Superlux",
        product_name: "PRA-383D",
        artnr: "015-601",
        thumb: "./images/ljud/pra383.png",
        description:
          "V",
        level: 4
    },
    {
        id: 15-611,
        category: "Mikrofoner",
        producer: "DPA",
        product_name: "4099",
        artnr: "015-611",
        thumb: "./images/ljud/DPA4099.png",
        description:
          "V",
        level: 4
    },
    {
        id: 15-821,
        category: "Mikrofoner",
        producer: "Shure",
        product_name: "Super 55SH-BCR",
        artnr: "015-821",
        thumb: "./images/ljud/sh55.png",
        description:
          "V",
        level: 4
    },
    {
        id: 15-901,
        category: "Mikrofoner",
        producer: "T.bone",
        product_name: "MM-1",
        artnr: "015-901",
        thumb: "./images/ljud/mm-1.png",
        description:
          "V",
        level: 4
    },
    {
        id: 15-902,
        category: "Mikrofoner",
        producer: "iSEMcon",
        product_name: "EMX-7150",
        artnr: "015-902",
        thumb: "./images/ljud/isemcon.png",
        description:
          "V",
        level: 4
    },
   // Trådlösa system

   
   
   
   // Lineboxar

    {
        id: 11-185,
        artnr: "010-555",
        category: "Lineboxar",
        product_name: "IMP2",
        producer: "Whirlwind",
        thumb: "./images/ljud/imp2.png",
        description:
          "IMP 2 Passiv DI-box. Instrument till mixer. Ingång: telehona. Utgångar: telehona till instrumentförstärkare och till mixer. Switch för Ground Lift.",
        level: 4
    },
    {
        id: 18-165,
        artnr: "010-555",
        category: "Lineboxar",
        product_name: "AR133",
        producer: "BSS",
        description:
          "V",
        thumb: "./images/ljud/ar133.png",
         //gallery images
         gallery_img:[
            {
                img:"./images/ljud/ar133.png",
            },
            {
                img:"./images/ljud/ar133-1.png",
            },
        ] ,
        level: 4
    },
    {
        id: 17-193,
        artnr: "010-555",
        category: "Lineboxar",
        product_name: "PcDI",
        producer: "Whirl Wind",
        description:
          "Stereo Direct Box för att koppla ihop dator/ljudkort med PA etc. Dämpar signalen ca -20dB eller -40dB med ”pad”. Sterero/mono-switch. Ingångar: 3,5mm stereotele, ¼”-tele och RCA. Utgångar: XLR.",
        thumb: "./images/ljud/pcdi.png",
        level: 4
    },
    {
        id: 18-1911,
        artnr: "010-555",
        category: "Lineboxar",
        product_name: "Bluetooth",
        producer: "Denon",
        level: 4,
        description:
          "Diskret och robust mottagare som tar emot signaler trådlöst via Bluetooth. Via dess balanserade XLR eller obalanserade 6,3 mm utgångar kan sedan signalen skickas vidare till mix eller förstärkarsystem. DN-200BR kommer ihåg 8st enheter i dess minne. Kopplas fler enheter upp, plockas automatisk den äldsta bort. XLR och ¼” utgångar Extern BNC-antenn Remote ”pair funktion” 20 Hz – 20 000Hz. Bluetooth version 4. Codec: SBC, MP3, AAC, aptX",
 
          // technical
        dimension:'149 x 117 x 45 mm',
        vikt_1:'0,6 kg',

        thumb: "./images/ljud/br200.png",
         //gallery images
         gallery_img:[
            {
                img:"./images/ljud/br200.png",
            },
            {
                img:"./images/ljud/br200_1.png",
            },
            {
                img:"./images/ljud/br200_2.png",
            },
                      
        ] ,
    },

    

    // LJUS

    // Ljusbord


    //Ljus Signalhantering
    {
        id: 31201,
        artnr: "031-201",
        category: "DMX Distribution",
        product_name: "E-node 8 Pro",
        producer: "Elation",
        thumb: "./images/no_img.png",
        level: 4
    },    

    // Moving Heads


    // Ramper


    // LED
    {
        id: 32-101,
        level: 4,
        category: "LED",
        product_name: "2 Bright Blind 3k IP",
        producer: "Ignition",
        artnr: "032-101",
        
        description:
        "En klassisk armatur för livekonserter m.m. Används ofta för att blända publiken eller låta glöda när man vill att publiken skall sjunga med ",  
        
        all_lists:[
            {
                list_data:"LED: 2 x 100 W Varmvit",
            },
            {
                list_data:"Spridning: 90°",
            },
            {
                list_data:"CRI: >90",
            },
            {
                list_data:"Färgtemperatur: 3000K",
            },
            {
                list_data:"DMX kanaler: 1/2/3/6",
            },
            {
                list_data:"IP: IP65",
            },
            {
                list_data:"Ström: True1 In / Ut",
            },
            {
                list_data:"DMX: XLR 3-pol In / Ut",
            },



        ],

        thumb: "./images/ljus/blinder.png",
        featured: "true",
         //gallery images

         gallery_img:[
            {
                img:"./images/ljus/blinder_back.png",
            },
            {
                img:"./images/ljus/blinder_case.png",
            },
            
           
        ] ,

         // technical
         dimension:'400 x 230 x 260 mm',
         vikt_1:'9 kg',

       // all cases
       all_cases:[ 
        {
            case_info:'För 2 st Blinders',
            vikt_2:"44 kg",
            storlek:"595 x 595 x 480 mm",
        },
    
     ],
      
        // icons
        icons:[
            {
                icon:"./images/icons/true1.png",
                hovertext:'True1',
            },
            {
                icon:"./images/icons/led.png",
                hovertext:'LED lampa',
            },
            
            {
                icon:"./images/icons/xlr3polv4.png",
                hovertext:'XLR 3-pol',
            },
            {
                icon:"./images/icons/triggerclamp.png",
                hovertext:'Trigger clamp',
            },
            {
                icon:"./images/icons/ip65.png",
                hovertext:'IP65',
            }
        ] ,

      // download
      downloadable_link:[
        {
            d_img:"./images/download.png",
            d_heading:"Ignition 2 Bright Blinder Manual",
            d_link:"./downloads/ignition_blinder.pdf"
        },
       
    ],
},
    {
        id: 32-520,
        level: 4,
        category: "LED",
        product_name: "Pro Slim Par 36 TLC",
        producer: "Futurelight",
        artnr: "032-520",
        
        description:
        "En klassisk LED lampa för att färga in. Varje diod är Röd, Grön och Blå. Kan används både som scenljus eller miljöljus", 
        all_lists:[
            {
                list_data:"Antal dioder: 18 st",
            },
            {
                list_data:"Diodtyp: 3 Watt TLC RGB diod",
            },
            {
                list_data:"Spridning: 18°",
                
            },
            {
                list_data:"DMX: 3-pol XLR In / Ut",    
            },
            {
                list_data:"DMX kanaler: 3/4/5/9", 
            },
            {
                list_data:"Musikstyrning: Har inbyggd mikrofon",
            },
            {
                list_data:"Max Effekt: 55 Watt",
            },
            {
                list_data:"Ström: PowerCon In / Ut",
            },
        ],
  
        
        featured: "true",
        
        //gallery images
         thumb: "./images/ljus/slimpar18.png",
         gallery_img:[
            {
                img:"./images/ljus/slimpar18.png",
            },
            {
                img:"./images/ljus/slimpar18_back.png",
            },
            
           
        ] ,

         // technical
         dimension:'263 x 100 x 300 mm',
         vikt_1:'4 kg',

       // all cases
       all_cases:[ 
        {
            case_info:'För 8 st Pro Slim Par',
            vikt_2:"64 kg",
            storlek:"900 x 600 x 600 mm",
        },
    
     ],
      
        // icons
        icons:[
            {
                icon:"./images/icons/powercon.png",
                hovertext:'PowerCon',
            },
            {
                icon:"./images/icons/led.png",
                hovertext:'LED lampa',
            },
            {
                icon:"./images/icons/rgb.png",
                hovertext:'Röd Grön Blå',
            },
            
            {
                icon:"./images/icons/xlr3polv4.png",
                hovertext:'XLR 3-pol',
            },
            
            {
                icon:"./images/icons/sound.png",
                hovertext:'Ljudstyrd',
            },
          
          
        ] ,

      // download
      downloadable_link:[
        {
            d_img:"./images/download.png",
            d_heading:"Futurelight Pro Slim Par 18 TLC manual",
            d_link:"./downloads/slimpar18.pdf"
        },
       
    ],
},


{
    id: 32-103,
    level: 4,
    category: "LED",
    product_name: "Pro Slim Par 18 TLC RBG",
    producer: "Futurelight",
    artnr: "032-103",
    
    description:
    "En klassisk LED lampa för att färga in. Varje diod är Röd, Grön och Blå. Kan används både som scenljus eller miljöljus", 
    all_lists:[
        {
            list_data:"Antal dioder: 18 st",
        },
        {
            list_data:"Diodtyp: 3 Watt TLC RGB diod",
        },
        {
            list_data:"Spridning: 18°",
            
        },
        {
            list_data:"DMX: 3-pol XLR In / Ut",    
        },
        {
            list_data:"DMX kanaler: 3/4/5/9", 
        },
        {
            list_data:"Musikstyrning: Har inbyggd mikrofon",
        },
        {
            list_data:"Max Effekt: 55 Watt",
        },
        {
            list_data:"Ström: PowerCon In / Ut",
        },
    ],

    
    featured: "true",
    
    //gallery images
     thumb: "./images/ljus/slimpar18.png",
     gallery_img:[
        {
            img:"./images/ljus/slimpar18.png",
        },
        {
            img:"./images/ljus/slimpar18_back.png",
        },
        
       
    ] ,

     // technical
     dimension:'263 x 100 x 300 mm',
     vikt_1:'4 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'För 8 st Pro Slim Par',
        vikt_2:"64 kg",
        storlek:"900 x 600 x 600 mm",
    },

 ],
  
    // icons
    icons:[
        {
            icon:"./images/icons/powercon.png",
            hovertext:'PowerCon',
        },
        {
            icon:"./images/icons/led.png",
            hovertext:'LED lampa',
        },
        {
            icon:"./images/icons/rgb.png",
            hovertext:'Röd Grön Blå',
        },
        
        {
            icon:"./images/icons/xlr3polv4.png",
            hovertext:'XLR 3-pol',
        },
        
        {
            icon:"./images/icons/sound.png",
            hovertext:'Ljudstyrd',
        },
      
      
    ] ,

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Futurelight Pro Slim Par 18 TLC manual",
        d_link:"./downloads/slimpar18.pdf"
    },
   
],
},

  // LJUS

   // Moving Heads
   {
    id: 33401,
    category: "Moving Heads",
    product_name: "Hero Wash 300 FC",
    level: 4,
    producer: "Varytec",
    artnr: "033-401",
    description:
      "Shure mikrofon..Line array speaker zoom range from narrow 6° beam to wide 50° wash, Uniform illumination of the light cone. Sophisticated fan management with three selectable modes: Silent, Max and Auto. Adjustable pan and tilt range with selectable start and end points. 4 Selectable dimmer curves. Adjustable PWM",
    pdf: "./../assets/manuals/Varytec.pdf",
    featured: "true",
    thumb: "./images/ljus/Varytec300.png",
    //gallery images
    gallery_img:[
        {
            img:"./images/ljus/Varytec300.png",
        },        
    ] ,

    // technical
    dimension:'575 x 257 x 184 mm',
    vikt_1:'10 kg',

    // all cases
    all_cases:[ 
        {
        case_info:'För 4 st Elation ACL 360 Bar',
        vikt_2:"75 kg",
        storlek:"1100 x 640 x 470 mm",
        },
        {
        case_info:'För 8 st Elation ACL 360 Bar',
        vikt_2:"110 kg",
        storlek:"1200 x 600 x 600 cm",
        },
     ],
     
    // icons
    icons:[
        {
            icon:"./images/icons/triggerclamp.png",
            hovertext:'Trigger clamp',
        },
        {
            icon:"./images/icons/powercon.png",
            hovertext:'PowerCon',
        },
        {
            icon:"./images/icons/xlr3polv4.png",
            hovertext:'DMX 3-pol',
        },
        {
            icon:"./images/icons/xlr3polv4.png",
            hovertext:'DMX 3-pol',
        }
    ] ,
    // download
    downloadable_link:[
        {
            d_img:"./images/download.png",
            d_heading:"Varytec Hero Wash 300 FC Manual",
            d_link:"./downloads/Varytec Hero 300 FC manual.pdf"
        },
        
    ],
},

   {
    id: 33501,
    category: "Moving Heads",
    product_name: "ACL 360 Bar",
    level: 4,
    producer: "Elation",
    artnr: "033-501",
    description:
      "Shure mikrofon..Line array speaker zoom range from narrow 6° beam to wide 50° wash, Uniform illumination of the light cone. Sophisticated fan management with three selectable modes: Silent, Max and Auto. Adjustable pan and tilt range with selectable start and end points. 4 Selectable dimmer curves. Adjustable PWM",
    pdf: "./../assets/manuals/Varytec.pdf",
    featured: "true",
    thumb: "./images/ljus/Acl360.png",
    //gallery images
    gallery_img:[
        {
            img:"./images/ljus/Acl360.png",
        },
        {
            img:"./images/ljus/Acl3601.png",
        },
        {
            img:"./images/ljus/Acl3602.png",
        },
        {
            img:"./images/ljus/Acl3603.png",
        },
        {
            img:"./images/ljus/Acl3604.png",
        },
        {
            img:"./images/ljus/Acl3605.png",
        },
        
    ] ,

    // technical
    dimension:'575 x 257 x 184 mm',
    vikt_1:'10 kg',

    // all cases
    all_cases:[ 
        {
        case_info:'För 4 st Elation ACL 360 Bar',
        vikt_2:"75 kg",
        storlek:"1100 x 640 x 470 mm",
        },
        {
        case_info:'För 8 st Elation ACL 360 Bar',
        vikt_2:"110 kg",
        storlek:"1200 x 600 x 600 cm",
        },
     ],
     
    // icons
    icons:[
        {
            icon:"./images/icons/triggerclamp.png",
            hovertext:'Trigger clamp',
        },
        {
            icon:"./images/icons/powercon.png",
            hovertext:'PowerCon',
        },
        {
            icon:"./images/icons/xlr3polv4.png",
            hovertext:'DMX 3-pol',
        },
        {
            icon:"./images/icons/xlr3polv4.png",
            hovertext:'DMX 3-pol',
        }
    ] ,
    // download
    downloadable_link:[
        {
            d_img:"./images/download.png",
            d_heading:"Elation ACL 360 Bar Manual",
            d_link:"./downloads/acl_360_bar_-_user_manual.pdf"
        },
        {
            d_img:"./images/download.png",
            d_heading:"Elation ACL 360 Bar Ritning",
            d_link:"./downloads/elation_acl_360_bar_dimensional_drawings_5.pdf"
        },
        {
            d_img:"./images/download.png",
            d_heading:"Elation ACL 360 Bar DMX Mode",
            d_link:"./downloads/elation_acl_360_bar_dmx_traits_081516_5.pdf"
        },
    ],
},

{
    id: 33601,
    category: "Moving Heads",
    product_name: "Beam Ball 100",
    level: 4,
    producer: "Stairville",
    artnr: "033-601",
    description:
      "Shure mikrofon..Line array speaker zoom range from narrow 6° beam to wide 50° wash, Uniform illumination of the light cone. Sophisticated fan management with three selectable modes: Silent, Max and Auto. Adjustable pan and tilt range with selectable start and end points. 4 Selectable dimmer curves. Adjustable PWM",
    pdf: "./../assets/manuals/Varytec.pdf",
    featured: "true",
    thumb: "./images/ljus/beamball.png",
    //gallery images
    gallery_img:[
        {
            img:"./images/ljus/Beamball.png",
        },
        {
            img:"./images/ljus/beamball1.jpg",
        },
        {
            img:"./images/ljus/beamball2.jpg",
        },
              
    ] ,

    // technical
    dimension:'575 x 257 x 184 mm',
    vikt_1:'10 kg',

    // all cases
    all_cases:[ 
        {
        case_info:'För 4 st Elation ACL 360 Bar',
        vikt_2:"75 kg",
        storlek:"1100 x 640 x 470 mm",
        },
        {
        case_info:'För 8 st Elation ACL 360 Bar',
        vikt_2:"110 kg",
        storlek:"1200 x 600 x 600 cm",
        },
     ],
     
    // icons
    icons:[
        {
            icon:"./images/icons/triggerclamp.png",
            hovertext:'Trigger clamp',
        },
        {
            icon:"./images/icons/powercon.png",
            hovertext:'PowerCon',
        },
        {
            icon:"./images/icons/xlr3polv4.png",
            hovertext:'DMX 3-pol',
        },
        {
            icon:"./images/icons/xlr3polv4.png",
            hovertext:'DMX 3-pol',
        }
    ] ,
    // download
    downloadable_link:[
        {
            d_img:"./images/download.png",
            d_heading:"Elation ACL 360 Bar Manual",
            d_link:"./downloads/acl_360_bar_-_user_manual.pdf"
        },
        {
            d_img:"./images/download.png",
            d_heading:"Elation ACL 360 Bar Ritning",
            d_link:"./downloads/elation_acl_360_bar_dimensional_drawings_5.pdf"
        },
        {
            d_img:"./images/download.png",
            d_heading:"Elation ACL 360 Bar DMX Mode",
            d_link:"./downloads/elation_acl_360_bar_dmx_traits_081516_5.pdf"
        },
    ],
},








//KABEL

{
    id: 55-301,
    category: "3-Fas kabel",
    producer: "Malmbergs",
    product_name: "3-Fas kabel 32 A 10m",
    thumb: "./images/ljus/slimpar36.png",
    level: 4,
    // 
    artnr: "055-301",
    description:
    "Mer info kommer",   
    
    featured: "true",
     //gallery images
     gallery_img:[
        {
            img:"./images/ljus/slimpar36.png",
        },
        {
            img:"./images/ljus/slimpar36_back.png",
        },
        
       
    ] ,

     // technical
     dimension:'263 x 100 x 300 mm',
     vikt_1:'4 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'För 8 st Pro SLim Par',
        vikt_2:"64 kg",
        storlek:"900 x 600 x 600 mm",
    },

 ],
  
    // icons
    icons:[
        {
            icon:"./images/icons/powercon.png",
            hovertext:'PowerCon',
        },
        {
            icon:"./images/icons/led.png",
            hovertext:'LED lampa',
        },
        {
            icon:"./images/icons/wwcw.png",
            hovertext:'Varm/Kall vit',
        },
        
        {
            icon:"./images/icons/xlr3polv4.png",
            hovertext:'XLR 3-pol',
        },
      
      
    ] ,

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Futurelight Pro Slim Par 36 manual",
        d_link:"./downloads/slimpar36.pdf"
    },
   
],
},
{
    id: 55-301,
    category: "3-Fas kabel",
    producer: "Malmbergs",
    product_name: "3-Fas kabel 32 A 10m",
    thumb: "./images/ljus/slimpar36.png",
    level: 4,
    // 
    artnr: "055-301",
    description:
    "Mer info kommer",   
    
    featured: "true",
     //gallery images
     gallery_img:[
        {
            img:"./images/ljus/slimpar36.png",
        },
        {
            img:"./images/ljus/slimpar36_back.png",
        },
        
       
    ] ,

     // technical
     dimension:'263 x 100 x 300 mm',
     vikt_1:'4 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'För 8 st Pro SLim Par',
        vikt_2:"64 kg",
        storlek:"900 x 600 x 600 mm",
    },

 ],
  
    // icons
    icons:[
        {
            icon:"./images/icons/powercon.png",
            hovertext:'PowerCon',
        },
        {
            icon:"./images/icons/led.png",
            hovertext:'LED lampa',
        },
        {
            icon:"./images/icons/wwcw.png",
            hovertext:'Varm/Kall vit',
        },
        
        {
            icon:"./images/icons/xlr3polv4.png",
            hovertext:'XLR 3-pol',
        },
      
      
    ] ,

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Futurelight Pro Slim Par 36 manual",
        d_link:"./downloads/slimpar36.pdf"
    },
   
],
},


{
    id: 56-111,
    artnr: "056-555",
    category: "DMX kabel",
    product_name: "DMX övergång 5 -> 3",
    producer: "",
    level: 4,
    description:
      "DMX övergång från 5-pol Hane tilll 3-pol hona.",


    thumb: "./images/kabel/dmx5to3.png",

},
{
    id: 56-112,
    artnr: "056-556",
    category: "DMX kabel",
    product_name: "DMX övergång 3 -> 5",
    producer: "",
    level: 4,
    description:
      "DMX övergång från 3-pol Hane tilll 5-pol hona.",
    thumb: "./images/kabel/dmx3to5.png",

},
{
    id: 56-401,
    artnr: "056-401",
    category: "DMX kabel",
    product_name: "3-pol DMX 1 m",
    producer: "",
    level: 4,
    description:
      "3-Polig DMX kabel med XLR Neutrikdon och Cordial kabel.",
    thumb: "./images/noimg.png",
},
{
    id: 56-403,
    artnr: "056-403",
    category: "DMX kabel",
    product_name: "3-pol DMX 3 m",
    producer: "",
    level: 4,
    description:
      "3-Polig DMX kabel med XLR Neutrikdon och Cordial kabel.",
    thumb: "./images/noimg.png",
},
// TRUSS

//F31
{
    id: 61050,
    category: "F31 Truss",
    producer: "Global Truss",
    product_name: "F31 50 cm Black",
    thumb: "./images/rigging/F31050B.png",
    level: 4,
    artnr: "061-050",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'500 x 50 x 50 mm',
     vikt_1:'1,1 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F31 Datablad",
        d_link:"./downloads/F31datablad.pdf"
    },
   
],
},
{
    id: 61051,
    category: "F31 Truss",
    producer: "Global Truss",
    product_name: "F31 50 cm Alu",
    thumb: "./images/rigging/F31050A.png",
    level: 4,
    // 
    artnr: "061-050A",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'500 x 50 x 50 mm',
     vikt_1:'1,1 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F31 Datablad",
        d_link:"./downloads/F31datablad.pdf"
    },
   
],
},
{
    id: 61100,
    category: "F31 Truss",
    producer: "Global Truss",
    product_name: "F31 100 cm Black",
    thumb: "./images/rigging/F31100B.png",
    level: 4,
    // 
    artnr: "061-100",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'1000 x 50 x 50 mm',
     vikt_1:'1,4 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F31 Datablad",
        d_link:"./downloads/F31datablad.pdf"
    },
   
],
},
{
    id: 61101,
    category: "F31 Truss",
    producer: "Global Truss",
    product_name: "F31 100 cm Alu",
    thumb: "./images/rigging/F31100A.png",
    level: 4,
    // 
    artnr: "061-101A",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'1000 x 50 x 50 mm',
     vikt_1:'1,4 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F31 Datablad",
        d_link:"./downloads/F31datablad.pdf"
    },
   
],
},
{
    id: 61150,
    category: "F31 Truss",
    producer: "Global Truss",
    product_name: "F31 150 cm Black",
    thumb: "./images/rigging/F31150B.png",
    level: 4,
    // 
    artnr: "061-150",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'1500 x 50 x 50 mm',
     vikt_1:'1,9 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F31 Datablad",
        d_link:"./downloads/F31datablad.pdf"
    },
   
],
},
{
    id: 61151,
    category: "F31 Truss",
    producer: "Global Truss",
    product_name: "F31 150 cm Alu",
    thumb: "./images/rigging/F31150A.png",
    level: 4,
    // 
    artnr: "061-150A",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'1500 x 50 x 50 mm',
     vikt_1:'1,9 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F31 Datablad",
        d_link:"./downloads/F31datablad.pdf"
    },
   
],
},
{
    id: 61200,
    category: "F31 Truss",
    producer: "Global Truss",
    product_name: "F31 200 cm Black",
    thumb: "./images/rigging/F31200B.png",
    level: 4,
    // 
    artnr: "061-200",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'2000 x 50 x 50 mm',
     vikt_1:'2,4 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F31 Datablad",
        d_link:"./downloads/F31datablad.pdf"
    },
   
],
},
{
id: 61201,
category: "F31 Truss",
producer: "Global Truss",
product_name: "F31 200 cm Alu",
thumb: "./images/rigging/F31200A.png",
level: 4,
// 
artnr: "061-200A",
description:
"Levereras med koner, sprint och R-clips",   

featured: "true",
 //gallery images
 

 // technical
 dimension:'2000 x 50 x 50 mm',
 vikt_1:'2,4 kg',

// all cases
all_cases:[ 
{
    case_info:'',
    vikt_2:"",
    storlek:"",
},

],


// download
downloadable_link:[
{
    d_img:"./images/download.png",
    d_heading:"F31 Datablad",
    d_link:"./downloads/F31datablad.pdf"
},

],
},
{
    id: 61300,
    category: "F31 Truss",
    producer: "Global Truss",
    product_name: "F31 300 cm Black",
    thumb: "./images/rigging/F31300B.png",
    level: 4,
    // 
    artnr: "061-300",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'3000 x 50 x 50 mm',
     vikt_1:'3 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F31 Datablad",
        d_link:"./downloads/F31datablad.pdf"
    },
   
],
},
{
    id: 61601,
    category: "F31 Truss",
    producer: "Global Truss",
    product_name: "F31 Truss cube Black",
    thumb: "./images/rigging/F31cubeB.png",
    level: 4,
    // 
    artnr: "061-600",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'50 x 50 x 50 mm',
     vikt_1:'0,8 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F31 Datablad",
        d_link:"./downloads/F31datablad.pdf"
    },
   
],
},
{
    id: 61602,
    category: "F31 Truss",
    producer: "Global Truss",
    product_name: "F31 Truss cube Alu",
    thumb: "./images/rigging/F31cubeA.png",
    level: 4,
    // 
    artnr: "061-600A",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'50 x 50 x 50 mm',
     vikt_1:'0,8 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F31 Datablad",
        d_link:"./downloads/F31datablad.pdf"
    },
   
],
},
{
    id: 61635,
    category: "F31 Truss",
    producer: "Global Truss",
    product_name: "F31 135° Truss Cube Black",
    thumb: "./images/rigging/F31cube135B.png",
    level: 4,
    // 
    artnr: "061-635",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'500 x 50 x 50 mm',
     vikt_1:'1,1 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F31 Datablad",
        d_link:"./downloads/F31datablad.pdf"
    },
   
],
},

//F32
{
    id: 62050,
    category: "F32 Truss",
    producer: "Global Truss",
    product_name: "F32 50 cm Black",
    thumb: "./images/rigging/F32050.png",
    level: 4,
    // 
    artnr: "062-050",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'500 x 50 x 290 mm',
     vikt_1:'1,7 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F32 Datablad",
        d_link:"./downloads/F32datablad.pdf"
    },
   
],
},
{
    id: 62075,
    category: "F32 Truss",
    producer: "Global Truss",
    product_name: "F32 75 cm Black",
    thumb: "./images/rigging/F32075B.png",
    level: 4,
    // 
    artnr: "062-075",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'750 x 50 x 290 mm',
     vikt_1:'2,1 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F32 Datablad",
        d_link:"./downloads/F32datablad.pdf"
    },
   
],
},
{
    id: 62100,
    category: "F32 Truss",
    producer: "Global Truss",
    product_name: "F32 100 cm Black",
    thumb: "./images/rigging/F32100B.png",
    level: 4,
    // 
    artnr: "062-100",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'1000 x 50 x 290 mm',
     vikt_1:'2,5 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F32 Datablad",
        d_link:"./downloads/F32datablad.pdf"
    },
   
],
},
{
    id: 62150,
    category: "F32 Truss",
    producer: "Global Truss",
    product_name: "F32 150 cm Black",
    thumb: "./images/rigging/F32150B.png",
    level: 4,
    // 
    artnr: "062-150",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'1500 x 50 x 290 mm',
     vikt_1:'3,5 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F32 Datablad",
        d_link:"./downloads/F32datablad.pdf"
    },
   
],
},
{
    id: 62200,
    category: "F32 Truss",
    producer: "Global Truss",
    product_name: "F32 200 cm Black",
    thumb: "./images/rigging/F32200B.png",
    level: 4,
    // 
    artnr: "062-200",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'2000 x 50 x 290 mm',
     vikt_1:'4,6 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F32 Datablad",
        d_link:"./downloads/F32datablad.pdf"
    },
   
],
},
{
    id: 62300,
    category: "F32 Truss",
    producer: "Global Truss",
    product_name: "F32 300 cm Black",
    thumb: "./images/rigging/F32300b.png",
    level: 4,
    // 
    artnr: "062-300",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'3000 x 50 x 290 mm',
     vikt_1:'6,7 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F32 Datablad",
        d_link:"./downloads/F32datablad.pdf"
    },
   
],
},
{
    id: 62601,
    category: "F32 Truss",
    producer: "Global Truss",
    product_name: "F32 Dogbone Cornerbox",
    thumb: "./images/rigging/F32dogbone.png",
    level: 4,
    // 
    artnr: "062-601",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'50 x 50 x 290 mm',
     vikt_1:'1,2 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F32 Datablad",
        d_link:"./downloads/F32datablad.pdf"
    },
   
],
},
{
    id: 62602,
    category: "F32 Truss",
    producer: "Global Truss",
    product_name: "F32 > F34 Adapter",
    thumb: "./images/rigging/F32adapter.png",
    level: 4,
    // 
    artnr: "062-602",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'290 x 50 x 290 mm',
     vikt_1:'2 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F32 Datablad",
        d_link:"./downloads/F32datablad.pdf"
    },
   
],
},
{
    id: 62635,
    category: "F32 Truss",
    producer: "Global Truss",
    product_name: "F32 135° graders hörn",
    thumb: "./images/rigging/F32135deg.png",
    level: 4,
    // 
    artnr: "062-635",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
     

     // technical
     dimension:'900 x 50 x 290 mm',
     vikt_1:'2,8 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],
  
    
  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"F32 Datablad",
        d_link:"./downloads/F32datablad.pdf"
    },
   
],
},


//F34
{
    id: 64021,
    category: "F34 Truss",
    producer: "Global Truss",
    product_name: "F34 21 cm Black",
    thumb: "./images/rigging/F34021B.png",
    level: 4,
    // 
    artnr: "064-021",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
    

     // technical
     dimension:'210 x 290 x 290 mm',
     vikt_1:'2,5 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Global Truss F34 Datablad",
        d_link:"./downloads/datablad_F34.pdf"
    },
   
],
},
{
    id: 64025,
    category: "F34 Truss",
    producer: "Global Truss",
    product_name: "F34 25 cm Black",
    thumb: "./images/rigging/F34025B.png",
    level: 4,
    // 
    artnr: "064-025",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
    

     // technical
     dimension:'250 x 290 x 290 mm',
     vikt_1:'2,9 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Global Truss F34 Datablad",
        d_link:"./downloads/datablad_F34.pdf"
    },
   
],
},
{
    id: 64050,
    category: "F34 Truss",
    producer: "Global Truss",
    product_name: "F34 50 cm Black",
    thumb: "./images/rigging/F34050.png",
    level: 4,
    // 
    artnr: "064-050",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
    

     // technical
     dimension:'500 x 290 x 290 mm',
     vikt_1:'4,9 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Global Truss F34 Datablad",
        d_link:"./downloads/datablad_F34.pdf"
    },
   
],
},
{
    id: 64075,
    category: "F34 Truss",
    producer: "Global Truss",
    product_name: "F34 75 cm Black",
    thumb: "./images/rigging/F34050.png",
    level: 4,
    // 
    artnr: "064-075",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
    

     // technical
     dimension:'750 x 290 x 290 mm',
     vikt_1:'7 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Global Truss F34 Datablad",
        d_link:"./downloads/datablad_F34.pdf"
    },
   
],
},
{
    id: 64100,
    category: "F34 Truss",
    producer: "Global Truss",
    product_name: "F34 100 cm Black",
    thumb: "./images/rigging/F34100B.png",
    level: 4,
    // 
    artnr: "064-100",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
    

     // technical
     dimension:'1000 x 290 x 290 mm',
     vikt_1:'7,5 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'Hjulplatta för truss',
        vikt_2:"5 kg",
        storlek:"",
    },

 ],

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Global Truss F34 Datablad",
        d_link:"./downloads/datablad_F34.pdf"
    },
   
],
},
{
    id: 64150,
    category: "F34 Truss",
    producer: "Global Truss",
    product_name: "F34 150 cm Black",
    thumb: "./images/rigging/F34150B.png",
    level: 4,
    // 
    artnr: "064-150",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
    

     // technical
     dimension:'1500 x 290 x 290 mm',
     vikt_1:'9,7 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'Hjulplatta för truss',
        vikt_2:"5 kg",
        storlek:"",
    },

 ],

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Global Truss F34 Datablad",
        d_link:"./downloads/datablad_F34.pdf"
    },
   
],
},
{
    id: 64200,
    category: "F34 Truss",
    producer: "Global Truss",
    product_name: "F34 200 cm Black",
    thumb: "./images/rigging/F34200B.png",
    level: 4,
    // 
    artnr: "064-200",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
    

     // technical
     dimension:'2000 x 290 x 290 mm',
     vikt_1:'12 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'Hjulplatta för truss',
        vikt_2:"5 kg",
        storlek:"",
    },

 ],

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Global Truss F34 Datablad",
        d_link:"./downloads/datablad_F34.pdf"
    },
   
],
},
{
    id: 64300,
    category: "F34 Truss",
    producer: "Global Truss",
    product_name: "F34 300 cm Black",
    thumb: "./images/rigging/F34300B.png",
    level: 4,
    // 
    artnr: "064-300",
    description:
    "Levereras med koner, sprint och R-clips",   
    
    featured: "true",
     //gallery images
    

     // technical
     dimension:'3000 x 290 x 290 mm',
     vikt_1:'16 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'Hjulplatta för truss',
        vikt_2:"5 kg",
        storlek:"",
    },

 ],

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Global Truss F34 Datablad",
        d_link:"./downloads/datablad_F34.pdf"
    },
   
],
},
{
    id: 64601,
    category: "F34 Truss",
    producer: "Global Truss",
    product_name: "F34 Cornerbox",
    thumb: "./images/rigging/F34box.png",
    level: 4,
    // 
    artnr: "064-601",
        
    description:
    "Cornerbox byggs enkelt till det hörn du önskar. Vi har en rad olika tillbehör för att kunna skapa det hörn du behöver, från ett 90 graders hörn till ett 6-vägs hörn",   
    
    featured: "true",
     //gallery images
    

     // technical
     dimension:'290 x 290 x 290 mm',
     vikt_1:'5,7 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Global Truss F34 Datablad",
        d_link:"./downloads/datablad_F34.pdf"
    },
   
],
},
{
    id: 64645,
    category: "F34 Truss",
    producer: "Global Truss",
    product_name: "F34 135° graders hörn",
    thumb: "./images/rigging/F34135deg.png",
    level: 4,
    // 
    artnr: "064-645",
    description:
    "Levereras med koner, sprint och R-clips.",   
    
    featured: "true",
     //gallery images
    

     // technical
     dimension:'900 x 290 x 290 mm',
     vikt_1:'6 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Global Truss F34 Datablad",
        d_link:"./downloads/datablad_F34.pdf"
    },
   
],
},
{
    id: 64701,
    category: "F34 Truss",
    producer: "Global Truss",
    product_name: "F34 Rörtopp",
    thumb: "./images/rigging/F34toptube.png",
    level: 4,
    // 
    artnr: "064-701",
    all_lists:[
        {
            list_data:"Levereras med koner, sprint och R-clips.",
        },
        {
            list_data:"Använs för att fästa t.ex lampa ovanpå Trussen",
        },
    ],

    
    featured: "true",
     //gallery images
    

     // technical
     dimension:'500 x 290 x 290 mm',
     vikt_1:'2,7 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'',
        vikt_2:"",
        storlek:"",
    },

 ],

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Global Truss F34 Datablad",
        d_link:"./downloads/datablad_F34.pdf"
    },
   
],
},

//Ground Support
{
    id: 65001,
    category: "Ground Support",
    producer: "Global Truss",
    product_name: "Komplett Ground Support torn",
    thumb: "./images/rigging/F34towerv2.png",
    level: 4,
    // 
    artnr: "065-001",
    description:
    "Komplett system",   
    
    featured: "true",
     //gallery images
     gallery_img:[
        {
            img:"./images/rigging/F34towerv2.png",
        },
        {
            img:"./images/rigging/F34towertop.png",
        },
        {
            img:"./images/rigging/F34sleeve.png",
        },
        
       
    ] ,

     // technical
     dimension:'500 x 50 x 290 mm',
     vikt_1:'1 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'För 8 st Pro SLim Par',
        vikt_2:"64 kg",
        storlek:"900 x 600 x 600 mm",
    },

 ],
  
    // icons
    icons:[
        {
            icon:"./images/icons/powercon.png",
            hovertext:'PowerCon',
        },
        {
            icon:"./images/icons/led.png",
            hovertext:'LED lampa',
        },
        {
            icon:"./images/icons/wwcw.png",
            hovertext:'Varm/Kall vit',
        },
        
        {
            icon:"./images/icons/xlr3polv4.png",
            hovertext:'XLR 3-pol',
        },
      
      
    ] ,

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Futurelight Pro Slim Par 36 manual",
        d_link:"./downloads/slimpar36.pdf"
    },
   
],
},
{
    id: 65101,
    category: "Ground Support",
    producer: "Global Truss",
    product_name: "F34 Tower Top",
    thumb: "./images/rigging/F34towertop.png",
    level: 4,
    // 
    artnr: "065-101",
    description:
    "Komplett system",   
    
    featured: "true",
     //gallery images
     gallery_img:[
        {
            img:"./images/ljus/slimpar36.png",
        },
        {
            img:"./images/ljus/slimpar36_back.png",
        },
        
       
    ] ,

     // technical
     dimension:'500 x 50 x 290 mm',
     vikt_1:'1 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'För 8 st Pro SLim Par',
        vikt_2:"64 kg",
        storlek:"900 x 600 x 600 mm",
    },

 ],
  
    // icons
    icons:[
        {
            icon:"./images/icons/powercon.png",
            hovertext:'PowerCon',
        },
        {
            icon:"./images/icons/led.png",
            hovertext:'LED lampa',
        },
        {
            icon:"./images/icons/wwcw.png",
            hovertext:'Varm/Kall vit',
        },
        
        {
            icon:"./images/icons/xlr3polv4.png",
            hovertext:'XLR 3-pol',
        },
      
      
    ] ,

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Futurelight Pro Slim Par 36 manual",
        d_link:"./downloads/slimpar36.pdf"
    },
   
],
},
{
    id: 65102,
    category: "Ground Support",
    producer: "Global Truss",
    product_name: "F34 Sleeve block",
    thumb: "./images/rigging/F34sleeve.png",
    level: 4,
    // 
    artnr: "065-102",
    description:
    "Komplett system",   
    
    featured: "true",
     //gallery images
     gallery_img:[
        {
            img:"./images/ljus/slimpar36.png",
        },
        {
            img:"./images/ljus/slimpar36_back.png",
        },
        
       
    ] ,

     // technical
     dimension:'500 x 50 x 290 mm',
     vikt_1:'1 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'För 8 st Pro SLim Par',
        vikt_2:"64 kg",
        storlek:"900 x 600 x 600 mm",
    },

 ],
  
    // icons
    icons:[
        {
            icon:"./images/icons/powercon.png",
            hovertext:'PowerCon',
        },
        {
            icon:"./images/icons/led.png",
            hovertext:'LED lampa',
        },
        {
            icon:"./images/icons/wwcw.png",
            hovertext:'Varm/Kall vit',
        },
        
        {
            icon:"./images/icons/xlr3polv4.png",
            hovertext:'XLR 3-pol',
        },
      
      
    ] ,

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Futurelight Pro Slim Par 36 manual",
        d_link:"./downloads/slimpar36.pdf"
    },
   
],
},
{
    id: 65103,
    category: "Ground Support",
    producer: "Global Truss",
    product_name: "F34 Ground Support Base",
    thumb: "./images/rigging/F34base.png",
    level: 4,
    // 
    artnr: "065-103",
    description:
    "Komplett system",   
    
    featured: "true",
     //gallery images
     gallery_img:[
        {
            img:"./images/ljus/slimpar36.png",
        },
        {
            img:"./images/ljus/slimpar36_back.png",
        },
        
       
    ] ,

     // technical
     dimension:'500 x 50 x 290 mm',
     vikt_1:'1 kg',

   // all cases
   all_cases:[ 
    {
        case_info:'För 8 st Pro SLim Par',
        vikt_2:"64 kg",
        storlek:"900 x 600 x 600 mm",
    },

 ],
  
    // icons
    icons:[
        {
            icon:"./images/icons/powercon.png",
            hovertext:'PowerCon',
        },
        {
            icon:"./images/icons/led.png",
            hovertext:'LED lampa',
        },
        {
            icon:"./images/icons/wwcw.png",
            hovertext:'Varm/Kall vit',
        },
        
        {
            icon:"./images/icons/xlr3polv4.png",
            hovertext:'XLR 3-pol',
        },
      
      
    ] ,

  // download
  downloadable_link:[
    {
        d_img:"./images/download.png",
        d_heading:"Futurelight Pro Slim Par 36 manual",
        d_link:"./downloads/slimpar36.pdf"
    },
   
],
},

]

export default product_img_menu;